module.exports = {
  // 菜单栏Class
  menuClass: {
    enterprise: 'Overview of corporate accounts',
    personal: 'Personal Account Overview'
  },
  // 登录注册Class
  loginClass: {
    userLogin: 'User Login',
    account: 'Mobile No./ Email Add.',
    password: 'Password',
    login: 'Log in',
    registerTips: 'Cloud Money Log in',
    realName: 'Your Real Name',
    mobile: 'Your Mobile No.',
    verificationCode: 'Verification Code',
    submit: 'Submit',
    agreeTips: 'I Have Read and Agree',
    agreementTips: '《Cloud Money Agreement》',
    register: 'Register',
    registerTime: 'Register Time',
    registerDone: 'Register Done',
    tel: 'Mobile No'
  },
  // 企业账户&&个人账户Class
  accountClass: {
    accountRelated: 'Account Related',
    corporateAccounts: 'Overview of corporate accounts',
    accountManagement: 'Corporate associated account management',
    accountOverview: 'Personal Account Overview',
    overviewManagement: 'Overview of account management',
    cloudPoint: 'Cloud Point Account',
    TEUCurrency: 'TEU Currency',
    recharge: 'Recharge',
    membership: 'Purchase a membership',
    details: 'Transaction Details',
    membershipPeriod: 'Membership Period',
    benefitsAvailable: 'Benefits Available',
    welcome: 'Welcome',
    userID: 'User ID',
    accountID: 'AccountID',
    exit: 'Exit',
    personal: 'Personal',
    personalDetails: 'Individual transaction details',
    enterpriseDetails: 'Business transaction details',
    tips: 'Please enter the added user ID. If the added user is not registered, please register it first',
    inputAccountName: 'Please enter AccountID',
    personalAccountID: 'Personal AccountID',
    companyAccountID: 'Company AccountID'
  },
  // 企业交易明细&&个人交易明细Class
  tradingClass: {
    startDate: 'Start Date',
    endDate: 'End Date',
    transactionDate: 'Transaction date',
    tradeSources: 'Trade sources',
    transactionType: 'Transaction type',
    all: 'All',
    consumption: 'Consumption',
    reconciliation: 'Reconciliation',
    transactionGifts: 'Transaction Gifts',
    membershipRecharge: 'Membership Recharge',
    confirmMembership: 'Confirm Membership',
    confirmRecharge: 'Confirm Recharge',
    cloudBl: 'Cloud B/l',
    cloudBooking: 'Cloud Booking',
    cloudExhibition: 'Cloud Exhibition',
    cloudMondy: 'Cloud Mondy',
    mall: 'Higosky Mall',
    transactionTime: 'Transaction Time',
    trader: 'Trader',
    accountName: 'Account Name',
    transactionNo: 'Transaction No',
    transactionAmount: 'Transaction Amount',
    pointBalance: 'Member Point Balance ',
    amountPay: 'Amount actually paid (RMB)',
    note: 'Note',
    download: 'Download',
    query: 'Query',
    account: 'Account',
    queryOptions: 'QueryOptions',
    allForms: 'All Forms',
    selectStartTime: 'Click to select the start time',
    selctEndTime: 'Click to select the end time',
    inputTransactionNo: 'Please enter Transaction NO',
    selectTradeSources: 'Please select Trade sources',
    selectTransactionType: 'Please select Transaction type',
    startTime: 'Select start time',
    endTime: 'Select end time',
    invalidFormat: 'Transaction number format is not correct',
    deleteSuccessful: 'Delete successful！',
    deleteFailed: 'Delete failed!',
    inputId: 'Please enter your account ID',
    permissionstoast: 'Please select role permissions',
    addSuccess: 'Add successfully',
    modifySuccess: 'modify successfully',
    balance: 'Balance'

  },
  // 会员Class
  membersClass: {
    membersTips: 'A membership fee of XXXX is required',
    membersTips1: 'A membership fee of ',
    membersTips2: ' is required',
    bronzeMember: 'Bronze member',
    goldMember: 'Gold member',
    platinumMember: 'Platinum member',
    benefitsAvailable: 'Benefits Available',
    paymentChecking: 'Payment in Checking',
    membershipDetails: 'details',
    bemembers: 'Become a member and enjoy more rights!',
    nonmembbers: 'No rights for non-members',
    validity: 'Membership period',
    equity: 'Available interest',
    review: 'You have payment, waiting for the platform in artificial check to confirm',
    day: 'day'
  },
  // 充值Class
  rechargeClass: {
    rechargeAmount: 'Recharge Amount',
    wechatPay: 'WeChat pay',
    alipay: 'Alipay Payment',
    offlinePay: 'Offline Pay',
    qrcode: 'Payment QR Code',
    rechargeTips: 'Please remit XXXX YUAN to XXXX.Please contact customer service after remittance. If you have any questions, please contact XXXX',
    tips1: 'Please remit',
    tips2: 'YUAN',
    tips3: 'to',
    tips4: '',
    tips5: 'Account name is',
    tips6: 'Please contact customer service after remittance. If you have any questions, please contact',
    rechargeTips: 'Recharge completed, Waiting for confirmation!',
    amountPaid: 'Payment Amount',
    paymentMethod: 'Payment Method',
    level: 'Membership grade',
    selectTips: 'Select a payment method',
    selectVip: 'Select a membership level',
    selectPaid: 'Select a payment amount',
    amountToast: 'Please select a payment amount',
    paymentToast: 'Please select a payment method',
    levelToast: 'Please select a membership grade'
  },
  // 充值支付
  rechargePayClass: {
    transactionNo: 'Transaction No.',
    transactionAmount: 'Transaction Amount',
    companyAccount: 'Company Account',
    vevificationCode: 'Vevification Code',
    enterCode: 'Pls Enter Code',
    send: 'Send',
    confirmPay: 'Confirm Pay',
    balance: 'Balance'
  },
  // 账号管理Class
  managementClass: {
    userID: 'User ID',
    userName: 'User Name',
    email: 'Email',
    permissions: 'Permissions',
    operation: 'Operation',
    administrator: 'Administrator (Chief of Enterprise)',
    payPart: 'Pay Part',
    update: 'Update',
    delete: 'Delete',
    addAccount: 'Add an associated account',
    updateAccount: 'Update an associated account',
    deleteAccount: 'Delete an associated account',
    addID: 'User ID is added',
    managementTips: 'Enter the added user ID.Rregister first if not yet.',
    deleteTips: 'Are you sure delete this associated account',
    cancel: 'cancel',
    setPermissions: 'Permissions',
    selectPermissions: 'Please select permissions',
    select: 'Select',
    sure: 'Sure',
    selectsure: 'confirm'
  },
  // table相关
  tableClass: {
    time: 'Time',
    transactionNo: 'TransactionNo',
    transactionAmount: 'Transaction Amount (TEU COIN)',
    amountAccount: 'AmountAccount (TEU COIN)',
    transactionType: 'TransactionType',
    tradeSources: 'TradeSources',
    amountPay: 'Amount actually paid (RMB)',
    usdAmountPay: 'Amount actually paid (USD)',
    trader: 'Trader',
    accountID: 'AccountID',
    accountName: 'Account Name',
    tel: 'Mobile No',
    email: 'Email',
    permissions: 'Permissions',
    operation: 'Operation'
  },
  bankTransferClass: {
    companyAccount: 'BENEFICIARY’S A/C NO.',
    remittanceAmount: 'Remittance Amount',
    bankAccount: 'BENEFICIARY’S BANK',
    account: 'BENEFICIARY',
    contact: 'Contact us',
    contactNumber: 'Tel.',
    contactWeChat: 'WeChat',
    unit: 'Yuan',
    email: 'Email',
    swift: 'SWIFT CODE',
    whatapp: 'WhatsApp',
    address: 'ADDRESS'
  },
  commonPayClass: {
    orderNo: 'Order No',
    purpose: 'Purpose',
    orderContent: 'Order Content',
    paymentMethod: 'Payment Method',
    amount: 'Amount',
    pay: 'Pay',
    commitBtn: 'Confirm',
    paymentCenter: 'Payment Center',
    currency: 'USD',
    paypalTitle: 'Paypal',
    recharge: 'Recharge'
  },
  commonPayResultClass: {
    statusSuccessTitle: 'Payment completed',
    statusFailTitle: 'Payment failed',
    resultSuccessTitle: 'Order payment completed',
    resultFailTitle: 'Order payment failed',
    orderNo: 'Order No',
    slipNo: 'Payment slip No',
    paymentMethod: 'Payment method',
    amount: 'Amount',
    returnBack: 'Back to Home Page',
    returnInvoiceBack: 'Apply for invoice',
    currency: 'USD',
    accountId: 'TEUCOIN Account',
    copyBtn: 'Copy',
    orderInfo: 'Order Content',
    generativeCharity: 'Generate charity certificate',
    accountInfo: 'Bank Account',
    viewOrder: 'View Order'
  },
  // 开具发票
  invoiceInfoClass: {
    companyName: 'Name',
    dutyParagraph: 'Duty Paragraph',
    address: 'Address',
    phone: 'Phone',
    bankName: 'Bank of deposit',
    bankCode: 'BankCode',
    amount: 'Issuing Amount',
    issuedPhone: 'Push Phone',
    issuedEmail: 'Push Mailbox'
  },
  //系统提示
  systemPromptInformation:{
    title : 'system prompt',
    content : 'Your registration information has been submitted and the staff will contact you as soon as possible'
  }
}
